import { UserContext } from "../../contexts/UserContext";
import { useGetUser } from "../../api/query_hooks";
import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const Oauth = () => {

    const { setSession } = useContext(UserContext);
    const userQuery = useGetUser();

    useEffect(() => {
        if(userQuery.isSuccess && !!userQuery.data.data) {
            setSession(userQuery.data?.data);
        }
    }, [userQuery]);


    if(userQuery.isError) return (
        <Navigate to={'/login'} />
    );

    return (
        <div className="bg-black d-flex justify-content-center align-items-center">
            <Spinner animation="border" role="status" aria-describedby="loading" />
        </div>
    )
}


export default Oauth;